import React, {
	memo, useState
}from 'react'
import {
	Tooltip, Upload
}from 'antd'
import validateFile from '../../helpers/validateFile'
import "./style.css"
import Attach from '../Icons/attach.svg'
import Delete from '../Icons/delete.svg'

const CustomUpload = memo(({
	multiple = false, maxCount = 5, disabled = false, isExcel = false, download = false, onDownload = null, defaultFileList = [], onChange = null, canEdit
}) => {
	const tooltip = [`Для загрузки доступны файлы форматов: ".jpg", "jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".tif", ".tiff". Размер файла должен быть до 15МБ`, `Для загрузки доступен формат файла: ".xlsx". Размер файла должен быть до 15МБ`]
	return (
		<Upload
			accept={ isExcel ? ".xls, .xlsx" : ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .tif, .tiff" }
			beforeUpload={ file => validateFile(file, isExcel) }
			className="upload-user-custom"
			customRequest={ null }
			defaultFileList={ defaultFileList }
			disabled={ disabled }
			iconRender={ () => null }
			itemRender={ (originNode, file, fileList, actions) => {
				return (
					<div className="custom-file">
						<Tooltip
							placement="left"
							title={ file.name ?? (file.fileName + file.fileExtension) }
						>
							<span
								style={ { cursor: (download && file.id) ? "pointer" : null } }
								onClick={ () => file.id && onDownload(file) }
							>
								{ file.name ?? (file.fileName + file.fileExtension) }
							</span>
						</Tooltip>
						{
							(!download || canEdit) &&
								(
									(
										<img
											src={ Delete }
											style={ { cursor: "pointer" } }
											onClick={ () => actions.remove() }
										/>
									)
								)
						}
					</div>
				)
			} }
			listType="text"
			maxCount={ maxCount }
			multiple={ multiple }
			onChange={ onChange ?? false }
		>
			{
				((!download || canEdit) &&
					(
						<Tooltip title={ tooltip[isExcel ? 1 : 0] }>
							<div className="add-file">
								<img
									src={ Attach }
								/>
								<span>
									{ `Добавить файл${ multiple ? "ы" : "" }` }
								</span>
							</div>
						</Tooltip>
					))
			}
		</Upload>
	)
})

export default CustomUpload